export const MAX_SPLASH_WIDTH = 650;
